import React, {  } from 'react';
import { useHistory } from "react-router-dom";
import { Config } from '../../public/js/config';
import './help.css';
import trans from './translation';
import loginLogoImg from '../../public/img/loginLogo.png';

const Help = (props) => {

    const history = useHistory();

    return (
        <div className='help'>
            <div className='logoBox'>
            <img src={loginLogoImg} />
                <div className='sysUpdate helpLoginBtn' onClick={() => history.push("/login")}>{trans.login[Config.backLang]}</div>
            </div>
            <div className='line'></div>
            <div className='helpBackground'>
                <div className='helpBox'>
                    <div className='helpTitleTop'>Help</div>
                    <div className='helpTitle'>Q1: What is Work-integrated Learning?</div>
                    <div className='helpInfo'>
                        A: Work-integrated Learning (WIL) in THEi integrates professional learning with practical application in the workplace. It is often referred to as industrial attachment, industry attachment or internship. For more information, visit: [THEi WIL]
                        (<a href='https://www.thei.edu.hk/industry-collaboration/work-integrated-learning-wil' target="_blank" rel="noreferrer">https://www.thei.edu.hk/industry-collaboration/work-integrated-learning-wil</a>).
                    </div>
                    <div className='helpTitle'>Q2: I am an Industry Partner and wish to explore WIL, what should I do?</div>
                    <div className='helpInfo'>A: We are excited to collaborate with you. For exploring WIL opportunities, please contact us at <span style={{color:'#D71920'}}>thei-wil-hub@thei.edu.hk</span>.</div>
                    <div className='helpTitle'>Q3: How to register for a WIL Digital Platform account?</div>
                    <div className='helpInfo'>A: To register for a WIL Digital Platform account, please contact us at <span style={{color:'#D71920'}}>thei-wil-hub@thei.edu.hk</span>. We are eager to assist you.</div>
                    <div className='helpTitle'>Q4: Can I access the WIL Digital Platform anywhere?</div>
                    <div className='helpInfo'>A: The WIL Digital Platform can be accessed worldwide through an internet-connected web browser.</div>

                    <div className='helpTitle'>Q5: Is the platform safe?</div>
                    <div className='helpInfo'>A: Data privacy and security are of utmost importance to us. We have strict controls, policies, and encryption in place to protect your data.</div>
                    <div className='helpTitle'>Q6: The WIL Digital Platform is not responding, can someone look into it?</div>
                    <div className='helpInfo'>A: We apologize for the inconvenience. Please notify us at  <span style={{color:'#D71920'}}>thei-wil-hub@thei.edu.hk</span> and we will work to resolve the situation promptly.</div>
                    <div className='helpTitle'>Q7: I have an account but not familiar with how to use it, what should I do?</div>
                    <div className='helpInfo'>A: If you need assistance with using your account, please log in to the platform. Under the &quot;Resource/FAQ&quot; menu selection, you will find self-help training tutorials and user help materials specifically designed to guide you.</div>
                    <div className='helpTitle'>Q8: Can I talk to someone about WIL or the WIL Digital Platform?</div>
                    <div className='helpInfo'>A: Certainly! To discuss any questions or concerns regarding WIL or the WIL Digital Platform, please contact the WIL Administrator at <span style={{color:'#D71920'}}>thei-wil-hub@thei.edu.hk</span>. We&apos;re here to assist you.</div>
                </div>
            </div>
            <div className='helpBottom'></div>
        </div>
    )
}

export default Help;